module.exports = __webpack_public_path__ + "static/img/companymap.18ba3e4a.png";